import {} from '@busybusy/webapp-react-ui';
import { CertificationEquipmentLink, Equipment } from '__generated__/graphql';
import classNames from 'classnames';
import { HeaderDialog } from 'components';
import ManageCertificationDialog from 'containers/manage-certifications/ManageCertificationsDialog/ManageCertificationsDialog';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';
import IEquipment from 'types/Equipment';
import EquipmentCertificationLinkForm from './EquipmentCertificationLinkForm';

export interface EquipmentCertificationsDetailsData
  extends Pick<CertificationEquipmentLink, 'id' | 'certificationId' | 'equipmentId' | 'cursor' | 'certification'> {}

export interface IEquipmentCertificationLinkFormDialogProps {
  className?: ClassName;
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  onSubmit: () => void;
  equipment: IEquipment | Equipment;
  certificationEquipmentLink?: EquipmentCertificationsDetailsData;
}

const EquipmentCertificationLinkFormDialog = (props: IEquipmentCertificationLinkFormDialogProps) => {
  const { className, isOpen, onClose, equipment, certificationEquipmentLink, onDelete, onSubmit } = props;

  const manageCertificationsDialog = useOpenable();

  const classes = classNames('equipment-certification-link-form-dialog', className);

  return (
    <>
      <HeaderDialog
        className={classes}
        isOpen={isOpen}
        title={certificationEquipmentLink ? t('Required Certification') : t('New Required Certification')}
        subtitle={equipment.equipmentName}
        onClose={onClose}
        divider={false}
      >
        <EquipmentCertificationLinkForm
          equipmentId={equipment.id}
          equipmentLink={certificationEquipmentLink}
          onDelete={onDelete}
          className={'p-5'}
          onManage={manageCertificationsDialog.open}
          onSubmit={onSubmit}
        />
      </HeaderDialog>
      <ManageCertificationDialog
        isOpen={manageCertificationsDialog.isOpen}
        onClose={manageCertificationsDialog.close}
      />
    </>
  );
};

export default EquipmentCertificationLinkFormDialog;
